/* Herlamora password / launch page: countdown tick + login panel. */
(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const initCountdown = (root) => {
    const target = new Date(root.dataset.target.replace(' ', 'T'));
    if (Number.isNaN(target.getTime())) {
      root.hidden = true;
      return;
    }
    const unit = {};
    root.querySelectorAll('[data-unit]').forEach((el) => {
      unit[el.dataset.unit] = el;
    });
    const numberOf = (el) => el.querySelector('.hlp__number');
    let timer = null;
    const tick = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        if (timer) clearInterval(timer);
        const message = root.dataset.expiredText;
        if (message) {
          const p = document.createElement('p');
          p.className = 'hlp__expired';
          p.textContent = message;
          root.replaceChildren(p);
        } else {
          root.hidden = true;
        }
        return;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor(diff / 3600000) % 24;
      const minutes = Math.floor(diff / 60000) % 60;
      const seconds = Math.floor(diff / 1000) % 60;
      if (unit.days) {
        unit.days.hidden = days === 0;
        numberOf(unit.days).textContent = pad(days);
      }
      if (unit.hours) numberOf(unit.hours).textContent = pad(hours);
      if (unit.minutes) numberOf(unit.minutes).textContent = pad(minutes);
      if (unit.seconds) numberOf(unit.seconds).textContent = pad(seconds);
    };
    tick();
    timer = setInterval(tick, 1000);
  };

  const init = () => {
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);

    /* Nach einem falschen Passwort rendert Shopify die Seite neu. Das
       Formular steht jetzt offen im Hero, die Meldung ist also ohnehin
       sichtbar -- der Cursor springt zurueck ins Feld, damit der zweite
       Versuch ohne Klick geht. (Frueher klappte hier ein <details> am
       Seitenende auf; das gibt es nicht mehr.) */
    const error = document.querySelector('.hlp__gate-error');
    if (error) {
      const input = document.querySelector('.hlp__gate-input');
      if (input) {
        input.focus({ preventScroll: true });
        input.scrollIntoView({ block: 'center' });
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
